import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  href: string;
}
export function Button({
  children,
  href,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" className={`inline-block bg-gold text-carbon font-bold uppercase tracking-wide px-8 py-4 rounded-lg transition-colors hover:bg-[#F5C736] hover:shadow-gold-glow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-carbon text-center ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-33">
      {children}
    </motion.a>;
}